import styled from "styled-components";
import Reveal from "../components/Reveal";
import { Container, Section, Eyebrow } from "../components/ui";
import config, { whatsappLink } from "../config";
import data from "../data/products.json";

export default function Contact() {
  return (
    <>
      <Top>
        <Container>
          <Reveal>
            <Eyebrow>Kontakt</Eyebrow>
            <H1>Na shkruaj dhe e marrim prej aty</H1>
            <Lead>
              Porositë bëhen me mesazh. Na thuaj cilin variant do dhe adresën —
              nuk ka formular, nuk ka llogari për të hapur.
            </Lead>
          </Reveal>
        </Container>
      </Top>

      <Section $tight>
        <Container>
          <Layout>
            <Reveal>
              <Big
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
              >
                <BigIcon>
                  <svg
                    viewBox="0 0 24 24"
                    width="26"
                    height="26"
                    fill="currentColor"
                  >
                    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.13a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.37c0-4.54 3.7-8.23 8.24-8.23a8.2 8.2 0 0 1 8.23 8.24c0 4.54-3.7 8.22-8.23 8.22z" />
                  </svg>
                </BigIcon>
                <div>
                  <BigTitle>WhatsApp</BigTitle>
                  <BigText>
                    Mënyra më e shpejtë. Përgjigjemi brenda ditës.
                  </BigText>
                </div>
                <Arrow>→</Arrow>
              </Big>
            </Reveal>

            <Reveal delay={0.07}>
              <Row>
                <Small
                  href={config.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SmallTitle>Instagram</SmallTitle>
                  <SmallText>Shkruaj në DM</SmallText>
                </Small>
                <Small
                  href={config.social.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SmallTitle>TikTok</SmallTitle>
                  <SmallText>Na ndiq për kontent</SmallText>
                </Small>
                <Small href={`mailto:${config.email}`}>
                  <SmallTitle>Email</SmallTitle>
                  <SmallText>{config.email}</SmallText>
                </Small>
              </Row>
            </Reveal>

            <Reveal delay={0.1}>
              <Quick>
                <QuickTitle>Porosit direkt një variant</QuickTitle>
                <Chips>
                  {data.products.map((p) => (
                    <Chip
                      key={p.slug}
                      href={whatsappLink(
                        `Përshëndetje! Dua të porosis Aroma Stick ${p.name}.`,
                      )}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ borderColor: p.accentSoft }}
                    >
                      <Swatch style={{ background: p.accent }} />
                      {p.name}
                    </Chip>
                  ))}
                </Chips>
                <Fine>
                  {config.price} · {config.shipping} · {config.bundle}
                </Fine>
              </Quick>
            </Reveal>
          </Layout>
        </Container>
      </Section>

      <Spacer />
    </>
  );
}

const Top = styled.header`
  padding: 148px 0 0;
  ${({ theme }) => theme.bp.md} {
    padding: 190px 0 0;
  }
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.size.h1};
  max-width: 16ch;
  margin-bottom: 20px;
`;

const Lead = styled.p`
  font-size: ${({ theme }) => theme.size.lg};
  color: ${({ theme }) => theme.colors.inkSoft};
  max-width: 48ch;
`;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Big = styled.a`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px;
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.colors.whatsapp};
  color: #fff;
  transition:
    transform 0.4s ${({ theme }) => theme.ease},
    box-shadow 0.4s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 40px -16px rgba(37, 211, 102, 0.7);
  }

  ${({ theme }) => theme.bp.md} {
    padding: 38px 40px;
  }
`;

const BigIcon = styled.span`
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.2);
`;

const BigTitle = styled.div`
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.xl};
`;

const BigText = styled.div`
  font-size: ${({ theme }) => theme.size.sm};
  color: rgba(255, 255, 255, 0.88);
`;

const Arrow = styled.span`
  margin-left: auto;
  font-size: 1.4rem;
`;

const Row = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.bp.sm} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Small = styled.a`
  padding: 26px 28px;
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.line};
  background: ${({ theme }) => theme.colors.surface};
  transition:
    border-color 0.35s ease,
    transform 0.35s ${({ theme }) => theme.ease};

  &:hover {
    transform: translateY(-3px);
    border-color: ${({ theme }) => theme.colors.ink};
  }
`;

const SmallTitle = styled.div`
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.lg};
  margin-bottom: 4px;
`;

const SmallText = styled.div`
  font-size: ${({ theme }) => theme.size.sm};
  color: ${({ theme }) => theme.colors.inkSoft};
  word-break: break-word;
`;

const Quick = styled.div`
  margin-top: 26px;
  padding: 32px 28px 34px;
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.colors.bgAlt};
  border: 1px solid ${({ theme }) => theme.colors.line};

  ${({ theme }) => theme.bp.md} {
    padding: 40px;
  }
`;

const QuickTitle = styled.h2`
  font-size: ${({ theme }) => theme.size.h3};
  margin-bottom: 22px;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Chip = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 20px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1.5px solid ${({ theme }) => theme.colors.line};
  font-size: ${({ theme }) => theme.size.sm};
  font-weight: 500;
  transition:
    transform 0.3s ${({ theme }) => theme.ease},
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadow.soft};
  }
`;

const Swatch = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
`;

const Fine = styled.p`
  margin-top: 20px;
  font-size: ${({ theme }) => theme.size.xs};
  color: ${({ theme }) => theme.colors.inkFaint};
`;

const Spacer = styled.div`
  height: 60px;
  ${({ theme }) => theme.bp.md} {
    height: 100px;
  }
`;
